import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const S = ({ t, children }: { t: string; children: React.ReactNode }) => (
  <section style={{ marginTop: 36 }}>
    <h2 style={{ fontFamily: '"Noto Serif TC",serif', fontSize: 22, color: '#2B2520', margin: '0 0 10px' }}>{t}</h2>
    <div style={{ lineHeight: 1.9 }}>{children}</div>
  </section>
);

export default function PrivacyPage() {
  useEffect(() => { document.title = '隱私政策｜每日為孩子禱告'; window.scrollTo(0, 0); }, []);
  return (
    <div style={{ background: '#FAF6EF', minHeight: '100vh', color: '#3D3530', fontFamily: '"Noto Sans TC",sans-serif', fontSize: 18 }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '56px 22px 96px' }}>
        <Link to="/" style={{ color: '#2F7A78', textDecoration: 'none' }}>← 回到首頁</Link>
        <h1 style={{ fontFamily: '"Noto Serif TC",serif', fontSize: 34, margin: '24px 0 6px', color: '#2B2520' }}>隱私政策</h1>
        <p style={{ color: '#6B6158', margin: 0 }}>最後更新：2026 年 11 月 4 日</p>
        <p style={{ marginTop: 24, lineHeight: 1.9 }}>「每日為孩子禱告」（以下稱「本站」）是以個人／社群形式運作的每日禱告事工。我們重視您的隱私，以下說明本站如何蒐集、使用與保護您的個人資料。</p>
        <S t="一、我們蒐集哪些資料">
          <ul style={{ paddingLeft: 22 }}>
            <li>您訂閱、贊助或聯絡我們時主動提供的資料，例如姓名、電子郵件、電話，以及年付贈品的收件地址。</li>
            <li>您寫信或透過 Facebook 私訊與我們聯繫時的往來內容。</li>
            <li>瀏覽本站時，主機服務商可能自動記錄的基本技術資料（例如 IP 位址、瀏覽器類型、造訪時間），僅用於網站運作與安全維護。</li>
          </ul>
        </S>
        <S t="二、付款資料">
          本站的訂閱與贊助付款均由 PAYUNi 統一金流平台處理。您的信用卡號等付款資料直接在 PAYUNi 的頁面輸入，本站不會取得或儲存您的完整卡號。PAYUNi 對付款資料的處理，適用其自身的隱私權政策。我們只會收到確認付款所需的交易資訊，例如付款人姓名、電子郵件、金額與交易狀態。
        </S>
        <S t="三、資料的使用目的">
          <ul style={{ paddingLeft: 22 }}>
            <li>確認會員資格、提供會員專屬 Line 群組的加入方式。</li>
            <li>寄送年付專屬禮物或贊助回饋。</li>
            <li>回覆您的詢問，以及通知與訂閱相關的重要事項。</li>
          </ul>
          我們不會將您的個人資料出售、出租或交換給任何第三方，也不會用於上述目的以外的用途。
        </S>
        <S t="四、資料的分享">
          除了為完成付款（PAYUNi）、寄送禮物（物流業者）或依法令要求之外，我們不會將您的資料提供給他人。
        </S>
        <S t="五、資料保存與安全">
          我們只在提供服務所需的期間保存您的資料，並採取合理的措施保護資料安全。當您取消訂閱且不再需要相關資料時，可要求我們刪除。
        </S>
        <S t="六、Cookie 與第三方服務">
          本站可能使用必要的 Cookie 或瀏覽器儲存空間維持網站功能，並載入 Google Fonts 等第三方資源。本站連結的 Facebook、YouTube 及 PAYUNi 等外部網站，各自適用其隱私權政策。
        </S>
        <S t="七、您的權利">
          依台灣《個人資料保護法》，您可以向我們查詢、閱覽、補充、更正您的個人資料，或要求停止使用、刪除您的個人資料。
        </S>
        <S t="八、聯絡我們">
          對本政策或您的個人資料有任何問題，請寫信至 <a href="mailto:prayforchild2026@gmail.com" style={{ color: '#2F7A78' }}>prayforchild2026@gmail.com</a>，我們會盡快回覆。
        </S>
        <S t="九、政策修訂">
          本政策如有修訂，將公布於本頁並更新上方日期。
        </S>
      </div>
    </div>
  );
}
